import { render, staticRenderFns } from "./ProductsSection.vue?vue&type=template&id=61fd19b0&scoped=true"
import script from "./ProductsSection.vue?vue&type=script&lang=js"
export * from "./ProductsSection.vue?vue&type=script&lang=js"
import style0 from "./ProductsSection.vue?vue&type=style&index=0&id=61fd19b0&prod&lang=scss"
import style1 from "./ProductsSection.vue?vue&type=style&index=1&id=61fd19b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fd19b0",
  null
  
)

export default component.exports